<img
  [ngClass]="[borderColor + '-border']"
  [src]="(!src || showDefault ? defaultSrc : src) | safe : 'resourceUrl'"
  (error)="showDefault = true"
/>
